import type { Action, Reducer } from "@reduxjs/toolkit";
import {
    TracingState,
    TracingActionTypes,
    ADD_TRACE_EVENT,
    TRACING_SET_ENABLED,
    TRACING_CLEAR,
} from "./types";

// The enable flag persists across sessions (mirrors the `profiling-enabled` pattern in profiling/reducers.ts).
// Recorded traces are deliberately session-only — they are large and ephemeral.
const TRACING_ENABLED_KEY = "tracing-enabled";

const initialState: TracingState = {
    enabled: localStorage.getItem(TRACING_ENABLED_KEY) === "1",
    traces: [],
    maxTraces: 500,
};

export const tracingReducer: Reducer<TracingState, Action, TracingState> = (
    state = initialState,
    action: TracingActionTypes
): TracingState => {
    switch (action.type) {
        case ADD_TRACE_EVENT: {
            // Append, then ring-buffer trim to the last `maxTraces` entries.
            const traces = [...state.traces, action.trace];
            return {
                ...state,
                traces: traces.length > state.maxTraces ? traces.slice(traces.length - state.maxTraces) : traces,
            };
        }

        case TRACING_SET_ENABLED:
            localStorage.setItem(TRACING_ENABLED_KEY, action.enabled ? "1" : "0");
            return { ...state, enabled: action.enabled };

        case TRACING_CLEAR:
            return { ...state, traces: [] };

        default:
            return state;
    }
};
